import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ImageUploader from "../../components/ImageUploader/ImageUploader";
import supabase from "../../supabase";
import "./AddProperty.css";
import { useNotification } from "../../context/NotificationContext";

const AddProperty = () => {
  const [nom, setNom] = useState("");
  const [superficie, setSuperficie] = useState("");
  const [ageLogementAnnees, setAgeLogementAnnees] = useState("");
  const [departementId, setDepartementId] = useState("");
  const [departements, setDepartements] = useState([]);
  const [images, setImages] = useState([]);
  const [defaultImageIndex, setDefaultImageIndex] = useState(0);
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  useEffect(() => {
    const fetchDepartements = async () => {
      const { data, error } = await supabase
        .from("departements")
        .select("id, numero, nom")
        .order("numero", { ascending: true });

      if (error) {
        console.error("Erreur chargement départements:", error);
      } else {
        setDepartements(data);
      }
    };

    fetchDepartements();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nom.trim() || !superficie.trim() || images.length === 0 || !departementId || !ageLogementAnnees) {
      showNotification("Veuillez remplir tous les champs et ajouter au moins une image.", "warning");
      return;
    }

    try {
      const {
        data: { user },
        error: userError,
      } = await supabase.auth.getUser();

      if (userError || !user) {
        throw new Error("Utilisateur non authentifié.");
      }

      // Création de la propriété
      const { data: property, error: propertyError } = await supabase
        .from("properties")
        .insert([
          {
            name: nom,
            superficie: parseFloat(superficie),
            profile_id: user.id,
            departement_id: departementId,
            age_logement_annees: parseInt(ageLogementAnnees),
          },
        ])
        .select()
        .single();

      if (propertyError) throw propertyError;

      const propertyId = property.id;

      // Traitement des images
      const imagePromises = images.map((img, index) => {
        return new Promise((resolve, reject) => {
          if (!img.file) {
            reject(new Error("Fichier image manquant"));
            return;
          }

          const reader = new FileReader();

          reader.onload = async (event) => {
            const imageUrl = event.target.result;

            const { error } = await supabase.from("images").insert([
              {
                url: imageUrl,
                is_default: index === defaultImageIndex,
                property_id: propertyId,
              },
            ]);

            if (error) reject(error);
            else resolve();
          };

          reader.onerror = reject;
          reader.readAsDataURL(img.file); // 🔥 correct ici
        });
      });

      await Promise.all(imagePromises);

      showNotification("Propriété ajoutée avec succès !", "success");
      navigate("/properties");
    } catch (error) {
      console.error("Erreur lors de l’ajout de la propriété :", error);
      showNotification("Une erreur est survenue lors de l’ajout de la propriété.", "danger");
    }
  };

  return (
    <div className="add-property-container">
      <h2 className="text-center">Ajouter une Propriété</h2>
      <form onSubmit={handleSubmit} className="add-property-form">
        <div className="mb-3">
          <label htmlFor="nom" className="form-label">Nom de la propriété</label>
          <input
            type="text"
            id="nom"
            className="form-control"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            placeholder="Ex : Appartement Centre-ville"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="superficie" className="form-label">Superficie (m²)</label>
          <input
            type="number"
            id="superficie"
            className="form-control"
            value={superficie}
            onChange={(e) => setSuperficie(e.target.value)}
            placeholder="Ex : 85"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="ageLogementAnnees" className="form-label">Âge du logement (années)</label>
          <input
            type="number"
            id="ageLogementAnnees"
            className="form-control"
            value={ageLogementAnnees}
            onChange={(e) => setAgeLogementAnnees(e.target.value)}
            placeholder="Ex : 30"
          />
        </div>

        <div className="mb-3">
          <label htmlFor="departement" className="form-label">Département</label>
          <select
            id="departement"
            className="form-select"
            value={departementId}
            onChange={(e) => setDepartementId(e.target.value)}
          >
            <option value="">Sélectionner un département</option>
            {departements.map((dep) => (
              <option key={dep.id} value={dep.id}>
                {dep.numero} - {dep.nom}
              </option>
            ))}
          </select>
        </div>

        <ImageUploader
          images={images}
          setImages={setImages}
          defaultImageIndex={defaultImageIndex}
          setDefaultImageIndex={setDefaultImageIndex}
        />

        <div className="text-center mt-4">
          <button
            type="submit"
            className="btn btn-primary add-property-submit"
            disabled={!nom || !superficie || images.length === 0 || !departementId || !ageLogementAnnees}
          >
            Ajouter la Propriété
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProperty;
